const baseUrl = '/settings/mailchimp';
export default {

    getConfig() {
        return new Promise((resolve, reject) => {
            ApiClient.get(baseUrl, {}).then((response) => {
                resolve(response);
            }).catch((err) => {
                reject(err);
            });
        });
    },

    saveConfig(config) {
        const payload = {
            apikey: config.apikey.trim(),
            contacts_synchronization: {
                enabled: config.contacts_synchronization.enabled,
                filter: config.contacts_synchronization.filter
            }
        };
        return new Promise((resolve, reject) => {
            ApiClient.post(baseUrl, {}, payload).then((response) => {
                resolve(response);
            }).catch((err) => {
                reject(err);
            });
        });
    },

    updateConfig(config) {
        const tempMergeFields = [];
        config.contacts_synchronization.merge_fields.forEach((item) => {
            tempMergeFields.push({
                merge_id: item.merge_id,
                tag: item.tag,
                default_value: item.default_value
            });
        });
        const payload = {
            apikey: config.apikey.trim(),
            marketing: {
                audience_id: config.marketing.audience_id
            },
            contacts_synchronization: {
                enabled: config.contacts_synchronization.enabled,
                audience_id: config.contacts_synchronization.audience_id,
                filter: config.contacts_synchronization.filter,
                merge_fields: tempMergeFields
            },
        };
        return new Promise((resolve, reject) => {
            ApiClient.put(baseUrl, {}, payload).then((response) => {
                resolve(response);
            }).catch((err) => {
                reject(err);
            });
        });
    },


};
